import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { UserInfoService } from './user-info.service';

import { AuthGuard} from '../services/auth.guard';
import {Router} from '@angular/router';
import jwt_decode from 'jwt-decode';


@Injectable({
  providedIn: 'root'
})
export class AppHttpInterceptorService implements HttpInterceptor{

    constructor(private userInfo : UserInfoService,  private router : Router,
      private authservice: AuthGuard,) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      
      let contentType = "application/json";
    const token = this.userInfo.getUserToken();
    const parentToken=this.userInfo.getParentUser()
    if(req.url === 'https://tippi.linuxmantra.com/api/tickets') {  
let tippiToken="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImludGVncmF0aW9uQGxpbnV4bWFudHJhLmNvbSIsImN1cnJlbnRFbnRpdHkiOnsiaWQiOiI2NjdjMGE3M2I0NDkzOGJjYzFjZjJkNGEiLCJlbnRpdHlDb2RlIjoiR0lMUElOIn0sImN1cnJlbnRQcm9qZWN0Ijp7ImlkIjoiNjY3YzBlOWUzOTU1ZjAwYWFlYTFiNjFjIiwicHJvamVjdENvZGUiOiJQUkFHWUFOIn0sImlhdCI6MTcxOTk5MDcxMywiZXhwIjoxNzUxNTI2NzEzfQ.sOGm6jz9yoGQhcvjmkmvM3z97RYWswZ37uRmrcNZgzk"
      if (token) {
        // if (this.authservice.loggedin(tippiToken)) {
        //   sessionStorage.clear();
        //   window.location.reload();
        //   this.router.navigate(['/partner_login']);
        // }
        let headers = req.headers;
        if(!headers) {
          headers = new HttpHeaders();
        }
        headers.append('Authorization', 'Bearer-' + tippiToken);
        if(req.url.includes("bulkuser")){
          console.log(req.url)
          contentType="multipart/mixed";
        }
        headers.append('Content-Type',contentType);
        const tokenizedReq = req.clone({ headers: req.headers.set("Authorization",'Bearer-' + tippiToken)});
        return next.handle(tokenizedReq);
      }

      

    }else{

    
    if (token) {
     if(parentToken){
      if (this.authservice.loggedin(parentToken)) {
        sessionStorage.clear();
        window.location.reload();
        this.router.navigate(['/partner_login']);
      }
     }
      if (this.authservice.loggedin(token)) {
        sessionStorage.clear();
        window.location.reload();
        this.router.navigate(['/partner_login']);
      }
      let headers = req.headers;
      if(!headers) {
        headers = new HttpHeaders();
      }
      headers.append('Authorization', 'Bearer ' + token);
      if(req.url.includes("bulkuser")){
        console.log(req.url)
        contentType="multipart/mixed";
      }
      headers.append('Content-Type',contentType);
      const tokenizedReq = req.clone({ headers: req.headers.set("Authorization",'Bearer ' + token)});
      return next.handle(tokenizedReq);
    }}
    return next.handle(req);
  }


  
}
